define( [
	"../../var/pnum"
], function( pnum ) {
	return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/css/var/rnumnonpx.js
// module id = 612
// module chunks = 0